








import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import FreeInputtableObjectMenu from "./FreeInputtableObjectMenu.vue";

@Component({
  components: {
    FreeInputtableObjectMenu,
  }
})
export default class CircleSelectObjectMenu extends Mixins() {
  @Prop()
  source: IFreeInputableWrappedObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get unselectedButtonConfiguration(): { class: string, label: string, description: string } {
    return {
      class: "circle-select-object-menu-deselected",
      label: "データ選択",
      description: "入力方法をデータ選択に切り替えます。",
    };
  }
}
